/*
  L7 Produktseite (15.10.2026): „Passt dazu“ (sections/gw-passt-dazu) und „Zuletzt angesehen“ (sections/gw-zuletzt).
  1. Wischreihen: Pfeilknöpfe (echte <button> mit aria-controls) blättern um die sichtbare Breite, am Rand disabled,
     unsichtbar (hidden), wenn nichts überläuft. Keine Autobewegung; prefers-reduced-motion → kein weiches Scrollen.
  2. „Passt dazu“-Rückfall: nur wenn serverseitig keine ergänzenden Produkte da sind. Lädt /recommendations/products (related)
     als Section, sobald der Abschnitt in die Nähe kommt (600px), behält nur Karten aus demselben Bereich (data-b),
     bei Lotus Clean ohne Chlor/ausgeschlossene Hersteller (data-x), höchstens data-max. Nichts übrig → Abschnitt bleibt weg.
  3. „Zuletzt angesehen“: liest localStorage „fluco_sto_recentlyViewed“ (schreibt Stilettos theme.js), ohne aktuelles Produkt,
     höchstens data-max; EINE Anfrage /search?type=product&q=<h1>+<h2>…&section_id=gw-zuletzt-liste, erst bei Nähe (400px).
     „Liste leeren“ löscht den Schlüssel, meldet das per role=status und setzt den Fokus auf die Überschrift.
*/
(function () {
  if (window.gwEmpf) return;
  window.gwEmpf = true;

  var KEY = 'fluco_sto_recentlyViewed';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function nahe(el, margin, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        if (es[i].isIntersecting) { io.disconnect(); fn(); return; }
      }
    }, { rootMargin: margin + ' 0px' });
    io.observe(el);
  }

  function holen(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (t) {
      return new DOMParser().parseFromString(t, 'text/html');
    });
  }

  /* ---------- Pfeilknöpfe ---------- */
  function navUpdate(sec) {
    var nav = sec.querySelector('[data-gw-nav]');
    var l = sec.querySelector('[data-gw-scroller]');
    if (!nav || !l) return;
    var max = l.scrollWidth - l.clientWidth - 2;
    nav.hidden = max <= 0;
    nav.querySelectorAll('[data-gw-scroll]').forEach(function (b) {
      var zurueck = b.getAttribute('data-gw-scroll') === '-1';
      var aus = zurueck ? l.scrollLeft <= 2 : l.scrollLeft >= max;
      if (aus && b === document.activeElement) {
        var anderer = nav.querySelector('[data-gw-scroll="' + (zurueck ? '1' : '-1') + '"]');
        if (anderer) anderer.focus();
      }
      b.disabled = aus;
    });
  }
  function navInit(sec) {
    var l = sec.querySelector('[data-gw-scroller]');
    if (!l || l._gwNav) return;
    l._gwNav = true;
    var t;
    l.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(function () { navUpdate(sec); }); }, { passive: true });
    window.addEventListener('resize', function () { navUpdate(sec); });
    window.addEventListener('load', function () { navUpdate(sec); });
    /* Die CSS-Datei lädt nicht blockierend: Maße ändern sich, sobald sie greift → neu prüfen */
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { navUpdate(sec); });
      ro.observe(l);
      l.querySelectorAll('li').forEach(function (li) { ro.observe(li); });
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gw-scroll]');
      if (!b || !sec.contains(b)) return;
      var li = l.querySelector('li');
      var gap = parseFloat(getComputedStyle(l).columnGap) || 12;
      var w = li ? li.getBoundingClientRect().width + gap : 240;
      var weite = Math.max(w, Math.floor((l.clientWidth + gap) / w) * w);
      l.scrollBy({ left: (+b.getAttribute('data-gw-scroll')) * weite, behavior: reduce ? 'auto' : 'smooth' });
    });
    requestAnimationFrame(function () { navUpdate(sec); });
  }

  /* ---------- Passt dazu ---------- */
  function passtDazu(wrap) {
    var sec = wrap.querySelector('.gw-pd');
    if (!sec) return;
    var url = wrap.getAttribute('data-gw-pd-url');
    if (!url) { navInit(sec); return; }
    nahe(wrap, '600px', function () {
      holen(url).then(function (doc) {
        var bereich = wrap.getAttribute('data-b');
        var lotus = wrap.getAttribute('data-lotus') === '1';
        var max = parseInt(wrap.getAttribute('data-max'), 10) || 4;
        var selbst = wrap.getAttribute('data-h');
        var ul = sec.querySelector('[data-gw-scroller]');
        var n = 0;
        doc.querySelectorAll('[data-gw-pd-quelle] > li').forEach(function (li) {
          if (n >= max) return;
          if (li.getAttribute('data-b') !== bereich) return;
          if (lotus && li.getAttribute('data-x') === '1') return;
          if (li.getAttribute('data-h') === selbst) return;
          li.removeAttribute('data-b'); li.removeAttribute('data-x');
          ul.appendChild(document.importNode(li, true));
          n++;
        });
        if (!n) { wrap.remove(); return; }
        sec.hidden = false;
        navInit(sec);
      }).catch(function () { wrap.remove(); });
    });
  }

  /* ---------- Zuletzt angesehen ---------- */
  function lesen() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function zuletzt(wrap) {
    var sec = wrap.querySelector('.gw-zl');
    if (!sec) return;
    var selbst = wrap.getAttribute('data-h');
    var max = parseInt(wrap.getAttribute('data-max'), 10) || 8;
    var handles = lesen().filter(function (h) {
      return typeof h === 'string' && h !== selbst && /^[a-z0-9][a-z0-9-]*$/.test(h);
    }).slice(0, max);
    if (!handles.length) return;
    nahe(wrap, '400px', function () {
      var url = wrap.getAttribute('data-url') + handles.join('+') + '&section_id=' + encodeURIComponent(wrap.getAttribute('data-section'));
      holen(url).then(function (doc) {
        var ul = sec.querySelector('[data-gw-zl-liste]');
        var gefunden = {};
        doc.querySelectorAll('[data-gw-zl-quelle] > li').forEach(function (li) { gefunden[li.getAttribute('data-h')] = li; });
        var n = 0;
        handles.forEach(function (h) {
          if (gefunden[h]) { ul.appendChild(document.importNode(gefunden[h], true)); n++; }
        });
        if (!n) return;
        sec.hidden = false;
        navInit(sec);
      }).catch(function () {});
    });
    sec.addEventListener('click', function (e) {
      if (!e.target.closest('[data-gw-zl-leeren]')) return;
      try { localStorage.removeItem(KEY); } catch (err) {}
      var ul = sec.querySelector('[data-gw-zl-liste]');
      if (ul) ul.remove();
      var nav = sec.querySelector('[data-gw-nav]');
      if (nav) nav.remove();
      var btn = sec.querySelector('[data-gw-zl-leeren]');
      if (btn) btn.remove();
      var st = sec.querySelector('[data-gw-zl-status]');
      if (st) st.textContent = 'Ihr Verlauf ist geleert.';
      var h = sec.querySelector('.gw-zl__h');
      if (h) h.focus();
    });
  }

  function start() {
    document.querySelectorAll('.gw-pd-wrap').forEach(function (w) { if (!w._gw) { w._gw = true; passtDazu(w); } });
    document.querySelectorAll('[data-gw-zl]').forEach(function (w) { if (!w._gw) { w._gw = true; zuletzt(w); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  /* Theme-Editor: Abschnitt neu geladen */
  document.addEventListener('shopify:section:load', start);
})();
